import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import Chart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';

const TransactionStatusChart = ({ stats }) => {
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Transaction Status Distribution
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Breakdown of anonymized vs clean transactions
        </Typography>
        <Box height={300}>
          <Chart
            options={{
              chart: {
                type: 'pie',
              },
              labels: stats?.anonymizationStats?.map(item => item.name) || [],
              colors:
                stats?.anonymizationStats?.map(item =>
                  item.name === 'Clean'
                    ? theme.palette.success?.main || '#4caf50'
                    : theme.palette.error?.main || '#f44336'
                ) || [],
              legend: {
                position: 'bottom',
              },
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200,
                    },
                    legend: {
                      position: 'bottom',
                    },
                  },
                },
              ],
            }}
            series={stats?.anonymizationStats?.map(item => item.value) || []}
            type="pie"
            height={300}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default TransactionStatusChart;
